import { AuthService } from "./../../shared/models/auth.service";
import { WeGoConfig, IAPIResponse } from "./../../shared/config";
import { Injectable } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { Observable } from "rxjs/Observable";

@Injectable()

export class PrivacyStatementPopup {

    constructor(private authService: AuthService, private http: Http) { }

    public GetPrivacyBySignUpFormParam(signupFormParam: string): Observable<IAPIResponse> {
        let getPrivacyDetail = WeGoConfig.API_GET_PRIVACYSTATEMENTS_BYSIGNUPPARAM + "?signupFormParam=" + signupFormParam + "&type=Privacy";
        let headers = this.authService.GetHeader();
        let options = new RequestOptions({ headers: headers });
        return this.http
            .get(getPrivacyDetail, options)
            .map(this.authService.HandleAPIResponse)
            .catch(this.authService.HandleAPIError);
    }

    public ActionOnAccountActivationTermsCondition(
        tncHashId: string,
        action: number
      ): Observable<IAPIResponse> {
        let headers = this.authService.GetHeader();
        const getUrl =
          WeGoConfig.API_GET_ACTION_ON_ACCOUNT_ACTIVATION_TERMS_CONDITION +
          '?tncHashId=' +
          tncHashId +
          '&action=' +
          action;
        const options = new RequestOptions({ headers: headers });
        return this.http
          .get(getUrl, options)
          .map(this.authService.HandleAPIResponse)
          .catch(this.authService.HandleAPIError);
      }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/privacypopup/models/privacy-popup.service.ts